import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { DtoApiInfo, DtoNewMenu, DtoNewMenuItem } from '@common';
import { MenuService } from '../../../core';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
  selector: 'app-menu',
  imports: [MenuItemComponent, CommonModule, MatCardModule],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  //#region private fields ----------------------------------------------------
  private readonly menuService: MenuService;
  private apiInfo?: DtoApiInfo;
  //#endregion

  //#region public fields -----------------------------------------------------
  public currentYear: string;
  public menuItems: Array<DtoNewMenuItem>;
  public clientVersion: string;
  public clientEnvironment: string;
  //#endregion

  //#region public getters ----------------------------------------------------
  public get apiVersion(): string | undefined {
    return this.apiInfo?.version || undefined;
  }

  public get apiEnvironment(): string | undefined {
    if (this.apiInfo) {
      return this.apiInfo.environment.toLowerCase().startsWith('prod')
        ? undefined
        : this.apiInfo.environment.toUpperCase();
    } else {
      return undefined;
    }
  }
  //#endregion

  //#region Constructor & C° --------------------------------------------------
  public constructor(menuService: MenuService) {
    this.menuService = menuService;
    this.menuItems = new Array<DtoNewMenuItem>();
    this.currentYear = new Date().getFullYear().toString();
    this.apiInfo = undefined;
    this.clientVersion = menuService.getClientVersion();
    this.clientEnvironment = menuService.getClientEnvironment();
  }

  public ngOnInit(): void {
    this.menuService.getMenu().subscribe((menu: DtoNewMenu) => {
      this.sortMenuItems(menu.items);
      this.menuItems = menu.items;
      // this.menuItems = menu.items.filter((m: DtoNewMenuItem) => !m.isHidden || (m.children && m.children.length > 0));
    });
    this.menuService.getApiInfo().subscribe((info: DtoApiInfo) => {
      //in case of an error this is a dtopage
      if (!(info as unknown as Record<string, unknown>)['windowTitle']) {
        this.apiInfo = info;
      } else {
        this.apiInfo = undefined;
      }
    });
  }
  //#endregion

  //#region Auxiliary methods -------------------------------------------------
  private sortMenuItems(items: Array<DtoNewMenuItem>): void {
    items.sort((a: DtoNewMenuItem, b: DtoNewMenuItem) => a.sequence - b.sequence);
    items.forEach((item: DtoNewMenuItem) => {
      if (item.children) {
        this.sortMenuItems(item.children);
      }
    });
  }
  //#endregion
}
